module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{},"en":{},"fr":{},"de":{},"jp":{},"es":{},"pt":{},"it":{},"tw":{},"kr":{}}')
  delete Component.options._Ctor
}
